//The helper functions

// Marketing season year used in page titles, meta tags and headings.
// Bump it once a year when the client closes the season (it is NOT the
// calendar year - after the summer camps end we already advertise the
// next season). Keep in sync with the hardcoded year in
// resources/views/site/master.blade.php.
export const SEASON_YEAR = 2027

export const slugify = (string) => {
  const a = 'àáäâãåăæąçćčđďèéěėëêęğǵḧìíïîįłḿǹńňñòóöôœøṕŕřßşśšșťțùúüûǘůűūųẃẍÿýźžż·/_,:;'
  const b = 'aaaaaaaaacccddeeeeeeegghiiiiilmnnnnooooooprrsssssttuuuuuuuuuwxyyzzz------'
  const p = new RegExp(a.split('').join('|'), 'g')

  return string.toString().toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
    .replace(/&/g, '-and-') // Replace & with 'and'
    .replace(/[^\w\-]+/g, '') // Remove all non-word characters
    .replace(/\-\-+/g, '-') // Replace multiple - with single -
    .replace(/^-+/, '') // Trim - from start of text
    .replace(/-+$/, '') // Trim - from end of text
}

export const unslugify = (slug) => {
  if (typeof slug !== 'string') return ''
  let unslugged = slug.replace('-', ' ')
  return unslugged.charAt(0).toUpperCase() + unslugged.slice(1)

}

export const stripTrailingSlash = (str) => {
  return str.endsWith('/') ?
    str.slice(0, -1) :
    str
}

export const scrollTop = (position = 0, delay = 200) => {
  setTimeout(() => {
    window.scrollTo({
      behavior: 'smooth',
      top: position
    })
  }, delay)
}

export const buildUrl = (filters = {}) => {
  let str = ''

  for (let filter in filters) {
    if (filters[filter]) str += `${filter}=${filters[filter]}&`
  }

  return str
}

export const arabicToRoman = (number) => {
  if (isNaN(number)) return NaN

  var digits = String(+number).split(''),
    key = ['','C','CC','CCC','CD','D','DC','DCC','DCCC','CM',
      '','X','XX','XXX','XL','L','LX','LXX','LXXX','XC',
      '','I','II','III','IV','V','VI','VII','VIII','IX'],
    roman = '',
    i = 3

  while (i--) {
    roman = (key[+digits.pop() + (i * 10)] || '') + roman
  }

  return Array(+digits.join('') + 1).join('M') + roman
}

export const timeSince = (date) => {

  date = new Date(date.replace(/-/g, '/'))
  var seconds = Math.floor((new Date() - date) / 1000)

  var interval = seconds / 31536000
  if (interval > 1 && interval < 2) {
    return Math.floor(interval) + ' rok'
  }
  if (interval >= 2 && interval < 5) {
    return Math.floor(interval) + ' lata'
  }
  if (interval > 5) {
    return Math.floor(interval) + ' lat'
  }

  interval = seconds / 2592000
  if (interval > 1 && interval < 2) {
    return Math.floor(interval) + ' miesiąc'
  }
  if (interval >= 2 && interval < 5) {
    return Math.floor(interval) + ' miesiące'
  }
  if (interval > 5) {
    return Math.floor(interval) + ' miesięcy'
  }

  interval = seconds / 604800
  if (interval > 1 && interval < 2) {
    return Math.floor(interval) + ' tydzień'
  }
  if (interval >= 2) {
    return Math.floor(interval) + ' tygodnie'
  }

  interval = seconds / 86400
  if (interval > 1 && interval < 2) {
    return Math.floor(interval) + ' dzień'
  }
  if (interval >= 2) {
    return Math.floor(interval) + ' dni'
  }

  interval = seconds / 3600
  if (interval > 1 && interval < 2) {
    return Math.floor(interval) + ' godzinę'
  }
  if (interval >= 2 && interval < 5) {
    return Math.floor(interval) + ' godziny'
  }
  if (interval > 5) {
    return Math.floor(interval) + ' godzin'
  }

  interval = seconds / 60
  if (interval > 1 && interval < 2) {
    return Math.floor(interval) + ' minutę'
  }
  if (interval >= 2 && interval < 5) {
    return Math.floor(interval) + ' minuty'
  }
  if (interval > 5) {
    return Math.floor(interval) + ' minut'
  }
  return Math.floor(seconds) + ' sekund'
}

export const reformatDate = (dateStr) => {
  const dArr = dateStr.split('-')
  return dArr[2]+ '.' +dArr[1]+ '.' +dArr[0]
}
